import angular from "angular";

import BicycleOwnerBicyclesModuleRouting from "./bicycle-owner-bicycles.module.routing";

export default angular
  .module("vt-bicycle-owner-bicycles", [])
  .config(BicycleOwnerBicyclesModuleRouting);
